import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    resetSurveyState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const { setLoading, setError, setSuccess, resetSurveyState } =
  surveySlice.actions;

export default surveySlice.reducer;
